module.exports = __webpack_public_path__ + "img/strategy_sj.f09e450e.svg";